/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import ChainedBackend from 'i18next-chained-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import ConfigurableI18nBackend from './shared/configurability/ConfigurableI18nBackend';
import { defaultLocale } from './settings';

const options = {
  order: [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'path',
    'subdomain',
  ],
  caches: ['localStorage', 'cookie'],
  lookupQuerystring: 'lng',
};

const bundledResources = {
  en: {
    translation: {
      'error.page.title': 'Oops ...',
      'error.page.generic.title': 'Error occurred on our side',
      'error.page.generic.message': 'Please contact our support team for assistance',
      'error.page.http.title': 'Error {{ code }}',
      'error.page.http.message': 'Resource "{{ method }}" "{{ path }}" returned with status {{ code }}',
      'messages.cooperation.with': 'In cooperation with',
      'messages.epo': 'European Patent Office',
    },
  },
  lt: {
    translation: {
      'error.page.title': 'Oops ...',
      'error.page.generic.title': 'Error occurred on our side',
      'error.page.generic.message': 'Please contact our support team for assistance',
      'error.page.http.title': 'Error {{ code }}',
      'error.page.http.message': 'Resource {{ method }} {{ path }} returned with status {{ code }}',
      'messages.cooperation.with': 'In cooperation with',
      'messages.epo': 'European Patent Office',
    },
  },
};

i18n
  .use(ChainedBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem('i18nextLng') || 'en',
    backend: {
      backends: [ConfigurableI18nBackend, resourcesToBackend(bundledResources)],
      backendOptions: [{ loadPath: '/locales/{{lng}}/resource.json', allowMultiLoading: true }],
    },
    fallbackLng: defaultLocale,
    keySeparator: false,
    nsSeparator: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: true,
    },
    transSupportBasicHtmlNodes: true, // allow <br/> and simple html elements in translations
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'], // allowed html nodes
    debug: false,
    detection: options,
  })
  .then(() => {
    document.title = i18n.t('application.generic.title', { defaultValue: 'European Patent Office' });
  });

export default i18n;
